import { render } from "./PersonalInfo.vue?vue&type=template&id=48949083&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=48949083&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48949083"]])

export default __exports__